export enum TableStateChangeType {
  ADD_TABLE = 'ADD_TABLE',
  BOT_ENTER_TABLE = 'BOT_ENTER_TABLE',
  GAME_STARTED = 'GAME_STARTED',
  UPDATE_PLAYERS = 'UPDATE_PLAYERS',
}
